<div class="modal-header-wrapper" [ngClass]="isIOS() === true ? 'ios' : ''">
    <div class="text-wrapper" [class.font-weight-600]="bold">{{text}}</div>
    <div class="responsive-flex-wrapper" (click)="close.emit()">
        <i class="ti-close"></i>
    </div>
</div>
